import React from 'react'
import clsx from 'clsx'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import styles from './styles'

const useStyles = makeStyles(styles)

const HeadBar = ({ data, padding, weight }) => {
  const classes = useStyles({ padding, weight })

  return (
    <div className={classes.titleSection}>
      {data && data.map((info) => {
        if (!info.value) return null
        return (
          <div className={classes.infoItem} key={info.label}>
            <Typography variant="h4" className={classes.label}>
              {info.label}
            </Typography>
            <Typography
              variant="h4"
              className={clsx({
                [classes.capitalize]: info.capitalize,
                [classes.textRed]: info.textRed,
                [classes.textBrown]: info.textBrown,
                [classes.textOrange]: info.textOrange,
                [classes.textGreen]: info.textGreen,
              })}
            >
              {info.value}
            </Typography>
          </div>
        )
      })}
    </div>
  )
}

export default HeadBar
